<div class="col-12 col-md-12 mt-2">
    <div class="row">
        <div class="col-6 col-md-6">
            <div class="card">
                <div class="card-body">
                    <div class="widget-container fluid-height">
                        <div class="heading">
                            <i class="fa fa-solid fa-bookmark" style="color: #b81fff;"></i>&nbsp;{{"Advanced Input" |
                            translate}}
                        </div>
                        <div class="widget-content padded">
                            <div>
                                <h6 class="text-secondary">{{"Special Keys" | translate}}</h6>
                                <div class="special-keys-buttons">
                                    <!-- <button title="Power" (click)="press('power')" class="btn btn-primary btn-xs">
                                        <i class="fa fa-power-off"></i>
                                    </button> -->
                                    <button title="Unlock" (click)="press('menu')" class="btn btn-primary btn-xs">
                                        <i class="fa fa-unlock"></i>
                                    </button>
                                    <button title="Camera" (click)="press('camera')" class="btn btn-primary btn-xs">
                                        <i class="fa fa-camera"></i>
                                    </button>
                                    <button title="Search" (click)="press('search')" class="btn btn-primary btn-xs">
                                        <i class="fa fa-search"></i>
                                    </button>
                                    <button title="Refresh" (click)="refresh()" ng-if="device.platform == 'iOS'"
                                        class="btn btn-primary btn-xs">
                                        <i class="fa fa-refresh"></i>
                                    </button>
                                </div>

                                <h6 class="text-secondary">{{"Volume" | translate}}</h6>
                                <div class="btn-group">
                                    <button title="Mute" (click)="press('volume_mute')" class="btn btn-primary btn-xs">
                                        <i class="fa fa-volume-off"></i>
                                    </button>
                                    <button title="Volume Down" (click)="press('volume_down')"
                                        class="btn btn-primary btn-xs">
                                        <i class="fa fa-volume-down"></i>
                                    </button>
                                    <button title="Volume Up" (click)="press('volume_up')"
                                        class="btn btn-primary btn-xs">
                                        <i class="fa fa-volume-up"></i>
                                    </button>
                                </div>

                                <h6 class="text-secondary">{{"Media" | translate}}</h6>
                                <div class="btn-group">
                                    <button title="Previous" (click)="press('media_previous')"
                                        class="btn btn-primary btn-xs">
                                        <i class="fa fa-step-backward"></i>
                                    </button>
                                    <button title="Play/Pause" (click)="press('media_play_pause')"
                                        class="btn btn-primary btn-xs">
                                        <i class="fa fa-youtube-play"></i>
                                    </button>
                                    <button title="Next" (click)="press('media_next')" class="btn btn-primary btn-xs">
                                        <i class="fa fa-step-forward"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-6 col-md-6">
            <div class="card">
                <div class="card-body">
                    <div class="widget-container fluid-height">
                        <div class="heading">
                            <i class="fa fa-solid fa-bookmark" style="color: #707070;"></i>&nbsp; {{"Maintainance" |
                            translate}}
                        </div>
                        <div class="widget-content padded">
                            <button (click)="rebootDeviceTemplate(device_restart_template)"
                                class="btn btn-sm btn-danger">
                                <i class="fa fa-refresh"></i>&nbsp; {{"Restart Device" | translate}}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- navbar buttons -->
            <div class="navbarbutton" style="margin-top: 1vh;">
                <div class="controls as-cell" style="align-items: flex-end;">
                    <div class="btn-group btn-group-justified" style="width: 100%;">
                        <a device-control-key="menu" title="Menu" (click)="key('menu')"
                            class="btn btn-primary btn-lg no-transition">
                            <i class="fa fa-bars"></i>
                        </a>
                        <a (click)="key('home')" device-control-key="home" title="Home"
                            class="btn btn-primary btn-lg no-transition">
                            <i class="fa fa-home"></i>
                        </a>
                        <a device-control-key="app_switch" (click)="key('app_switch')" title="App switch"
                            class="btn btn-primary btn-lg no-transition">
                            <i class="fa fa-square-o"></i>
                        </a>
                        <a device-control-key="back" (click)="key('back')" title="Back"
                            class="btn btn-primary btn-lg no-transition">
                            <i class="fa fa-mail-reply"></i>
                        </a>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>

<!-- Modal -->

<ng-template #device_restart_template let-modal>
    <div class="modal-body text-center">
        <p class="alert-message">{{"Are you sure you want to reboot this device?" | translate}} <br>
            {{"The device will be unavailable for a moment." | translate}}
        </p>
        <div class="alert-actions">
            <button type="button" class="btn btn-success" (click)="reboot()">{{"Yes, Proceed" |
                translate}}</button>&nbsp;
            <button type="button" class="btn btn-danger" (click)="cancelRequest()">{{"No, Cancel" |
                translate}}</button>&nbsp;
        </div>
    </div>
</ng-template>